import { ModelFormatters } from '@/models/ModelFormatters';

export class ModelPropertyInfos {
  static DecimalNumber2Digits = {
    ToUserDataFormatter: ModelFormatters.ToUserData.DecimalNumberAsString(2, 2),
    ToModelDataFormatter: ModelFormatters.ToModelData.DecimalStringAsNumber()
  };
  static DecimalNumber = {
    ToUserDataFormatter: ModelFormatters.ToUserData.DecimalNumberAsString(),
    ToModelDataFormatter: ModelFormatters.ToModelData.DecimalStringAsNumber()
  };
  static IntegerNumber = {
    ToUserDataFormatter: ModelFormatters.ToUserData.IntegerNumberAsString(),
    ToModelDataFormatter: ModelFormatters.ToModelData.IntegerStringAsNumber()
  };
  static Text = {
    ToUserDataFormatter: ModelFormatters.ToUserData.Passthrough(),
    ToModelDataFormatter: (key, value) => value?.toString()
  };
  static TextUpperCase = {
    ToUserDataFormatter: ModelFormatters.ToUserData.Passthrough(),
    ToModelDataFormatter: (key, value) => value?.toString().toUpperCase()
  };
  static TextLowerCase = {
    ToUserDataFormatter: ModelFormatters.ToUserData.Passthrough(),
    ToModelDataFormatter: (key, value) => value?.toString().toLowerCase()
  };
}
